/*
 * Copyright (c) 2024 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, May 17th 2024, 9:16:28 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import InputIcon from "@mui/icons-material/Input";
import WarningIcon from "@mui/icons-material/Warning";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { FormField } from "lib/schemas";
import { useFieldTypesAPI } from "form-builder/services";
import { ListButtonAutoCompleteFormInput } from "ui-widgets/forms";
import { EmphasisText, HelperText } from "ui-widgets";
import { getFieldTypeWidgets } from "./FieldTypeWidgets";

const CustomPaper = ({ children }) => (
  <Paper sx={{ p: 2, mb: 2 }}>
    <HelperText>
      <Stack direction="row">
        <WarningIcon color="warning" />
        <EmphasisText>Warning</EmphasisText>
      </Stack>
      Changing the field type is a major change if your form already has existing data. It may result in loss of data or
      data corruption. Please be sure to change to a field type that can handle the same kind of data of the current
      field type.
    </HelperText>
    {children}
  </Paper>
);

export const FieldTypeFormInput = () => {
  const { useFetchAllFieldTypes } = useFieldTypesAPI();
  const { fieldTypes } = useFetchAllFieldTypes();
  return (
    <>
      <ListButtonAutoCompleteFormInput<FormField>
        PaperComponent={CustomPaper}
        schema_field_key="field_type"
        label="Field Type"
        options={Object.keys(fieldTypes)}
        getOptionLabel={(option) => {
          const [title] = getFieldTypeWidgets(option);
          return title || fieldTypes[option];
        }}
        getPrimaryOptionLabel={(option) => {
          const [, iconComponent] = getFieldTypeWidgets(option);
          return iconComponent || <InputIcon />;
        }}
        getSecondaryOptionLabel={(option) => {
          const [title] = getFieldTypeWidgets(option);
          return title || fieldTypes[option];
        }}
      />
    </>
  );
};
